'use strict';

intellidealerAppCoreModule.factory('worldpayResource', function ($resource, appConfigurationService) {

  return {
    authorizeInvoicePayment: function (param) {
      return $resource(appConfigurationService.basePath + '/rest/oem/worldpay/authorizeInvoicePayment', param, {post: {method: 'POST'}});
    },

    readInvoicePayment: $resource(appConfigurationService.basePath + '/rest/oem/worldpay/readInvoicePayment/', {}, {post: {method: 'POST'}}),

    acceptInvoiceSurcharge: function (param) {
      return $resource(appConfigurationService.basePath + '/rest/oem/worldpay/acceptInvoiceSurcharge', param, {post: {method: 'POST'}});
    },
  };
});
